import * as React from 'react';
import { OffersTenMinutes } from '../../components/OffersTenMinutes';
import { Advantages } from '../../components/Advantages';
import { Steps } from '../../components/Steps';
import { BanksListContainer } from '../../containers/BanksListContainer';
import { SubmitPhoneFormContainer } from '../../containers/SubmitPhoneFormContainer';
import { Notes } from '../../components/Notes';
import { ContactUs } from '../../components/ContactUs';
import { ShowcaseCatContainer } from '../../containers/ShowcaseCatContainer/ShowcaseCatContainer';
import { InterestRateContainer } from '../../containers/InterestRateContainer/InterestRateContainer';

export const MailPage = () => {
  return (
    <>
      <SubmitPhoneFormContainer Form={ShowcaseCatContainer} label="main_login_block" />
      <BanksListContainer />
      <Steps />
      <OffersTenMinutes />
      <InterestRateContainer />
      <Advantages />
      <ContactUs />
      <Notes />
    </>
  );
};
